import { render, staticRenderFns } from "./myBalance.vue?vue&type=template&id=feee57ce"
import script from "./myBalance.vue?vue&type=script&lang=js"
export * from "./myBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports